import { Component, input, output, OutputEmitterRef } from '@angular/core';
import { OshTreeItemComponent } from '@app/components/osh/osh-tree-item/osh-tree-item.component';
import { CreateOrEditOshAnalysisDialogData, Osh } from '@app/shared/types/models/osh/osh.model';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'proffeo-osh-tree',
  imports: [OshTreeItemComponent, TranslatePipe],
  templateUrl: './osh-tree.component.html'
})
export class OshTreeComponent {
  public readonly oshAnalysisEdited: OutputEmitterRef<CreateOrEditOshAnalysisDialogData> =
    output<CreateOrEditOshAnalysisDialogData>();
  public readonly oshAnalysisDeleted: OutputEmitterRef<string> = output<string>();

  public oshAnalyses = input.required<Osh[]>();

  protected editOshAnalysis(result: CreateOrEditOshAnalysisDialogData): void {
    this.oshAnalysisEdited.emit(result);
  }

  protected deleteOshAnalysis(analysisId: string): void {
    this.oshAnalysisDeleted.emit(analysisId);
  }
}
